import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RewardService} from "../../../../../shared/services/reward.service";
import {LogService} from "../../../../../shared/services/LogService";
import {properties} from "../../../../../../environments/properties";

@Component({
  selector: 'app-promotion-hero',
  templateUrl: './promotion-hero.component.html',
  styleUrls: ['./promotion-hero.component.scss']
})
export class PromotionHeroComponent implements OnInit {

  @Input() partnerDetails: any;
  partnerDetailContentURL: any;
  promotionHeroDataObj: any;
  promoURLObject: any = null;
  showLoading: any = true;
  @Input() isWebView;
  @Output() partnerRedeemObject: EventEmitter<any> = new EventEmitter();
  displayableBanner: string = '';
  constructor(
      private rewardService: RewardService,
      private logService: LogService
  ) { }

  ngOnInit(): void {
    if (this.partnerDetails) {
      if (this.partnerDetails.contentPath) {
        this.partnerDetailContentURL = this.partnerDetails.contentPath;
        this.displayableBanner = properties.rewardsConfig.displaybleBannerNames[this.partnerDetails.banner];
        if(this.isWebView) {
          this.partnerDetailContentURL = this.rewardService.getMobileApplicationDomainURL(this.partnerDetails.currentEnvironment, this.partnerDetails.banner) + '/' + this.partnerDetailContentURL.replace(/\{partner_section\}/g, 'hero');
        } else {
          this.partnerDetailContentURL = this.rewardService.getApplicationDomainURL() + '/' + this.partnerDetailContentURL.replace(/\{partner_section\}/g, 'hero');
        }
        this.getPartnerDetailContentAPI();
      }
    }
  }
  getPartnerDetailContentAPI(){
    this.rewardService.getPromotionDetailContent(this.partnerDetailContentURL).subscribe((promotionDetailData: any) => {
      this.showLoading = false;
      this.promotionHeroDataObj = this.replaceHeroHeadingTag(this.replaceAltAttribute(promotionDetailData));
      this.promotionHeroDataObj = this.rewardService.replaceBannerInContent(this.promotionHeroDataObj, this.partnerDetails.banner);
    }, error => {
        this.showLoading = false;
        if(this.isWebView) {
          this.logService.log('error', 'Web View : ERROR'+ ' : ' + JSON.stringify(error), this.partnerDetails.currentEnvironment, this.partnerDetails.banner);
        }
    })
  }

  replaceHeroHeadingTag(html: string): string{
  return html.replace(/<span class="hero-intro__heading"(.*?)>(.*?)<\/span>/gi,
   `<h1 class="hero-intro__heading" role="heading" aria-level="1" $1>$2</h1>`);
  }

  replaceAltAttribute(html: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const img  = doc.querySelector('.hero-intro.hero-intro--with-plate .hero-intro__image picture  img');
    if(img.hasAttribute('alt') && img.getAttribute('alt')?.trim() !== ''){
      img.setAttribute('alt','');
    }
    return doc.body.innerHTML;
  }

  getPartnerRedeemObject(data){
    if(data){
      this.partnerRedeemObject.emit(data);
    }
  }
}
